/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelDraft } from '../../models/travel-draft';

export interface TravelControllerDeleteDraft$Params {
  id: number;
}

export function travelControllerDeleteDraft(http: HttpClient, rootUrl: string, params: TravelControllerDeleteDraft$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelDraft;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerDeleteDraft.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelDraft;
      }>;
    })
  );
}

travelControllerDeleteDraft.PATH = '/travel/draft/{id}';
